import React from 'react';
import BubbleInput, { BubbleInputBase, BubbleInputBaseCheckbox } from './BubbleInput';

interface BubbleCheckboxPropsBase {
  label: string;
  inline?: boolean;
  labelRender?: (label: string) => React.ReactNode;
}

export type BubbleCheckboxProps<T> = BubbleCheckboxPropsBase &
  Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'size'> &
  BubbleInputBase<T> &
  Omit<BubbleInputBaseCheckbox, 'type'>;

export default function BubbleCheckbox<T = boolean>(props: BubbleCheckboxProps<T>) {
  const {
    className: propClassName,
    inputClassName: propInputClassName,
    inline,
    label,
    labelRender,
    subtitle,
    ...rest
  } = props;

  const inputClasses = ['stretched-link skip-errors'];
  if (propInputClassName) inputClasses.push(propInputClassName);

  const classes = [
    'bubble-checkbox-container',
    inline ? 'inline-flex' : 'flex',
    'relative items-start',
  ];
  if (propClassName) classes.push(propClassName);

  return (
    <div className={classes.join(' ')}>
      <BubbleInput {...rest} type="checkbox" inputClassName={inputClasses.join(' ')} />
      <div className="ml-1">
        <div>{labelRender ? labelRender(label) : label}</div>
        {subtitle && <div className="text-xs text-smoke italic">{subtitle}</div>}
      </div>
    </div>
  );
}
